export default __webpack_public_path__ + "3955954011c7ae2b12dafac968f72901.jpg";